<template>
    <CardRh :processando="processando" titulo="FALTAS CADASTRADAS">
        <div class="falta-index-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span> 
                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaFalta" class="form-label">Pesquisar</label>
                        <input id="pesquisaFalta" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Aluno, turma ou disciplina" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataMinFalta" class="form-label">Data Minima</label>
                        <input id="dataMinFalta" v-model="data_min" @keyup="apertouEnter" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataMaxFalta" class="form-label">Data Maxima</label>
                        <input id="dataMaxFalta" v-model="data_max" @keyup="apertouEnter" @blur="refreshTable"
                            type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="cpfFalta" class="form-label">CPF aluno</label>
                        <input id="cpfFalta" v-model="cpf" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="CPF" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-1">
                        <label for="pelotaoFalta" class="form-label">Pelotão</label>
                        <input id="pelotaoFalta" v-model="pelotao" @keyup="apertouEnter" type="text" class="form-control form-control-solid" placeholder="Pelotão" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2" v-if="status">
                        <label for="statusFalta" class="form-label">Status</label>
                        <Multiselect id="statusFalta" @change="refreshTable" :options="status_select" :searchable="true" v-model="status_id" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="turmaAula" class="form-label">Turma</label>
                        <input id="turmaAula" v-model="turma" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Turma" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="disciplinaAula" class="form-label">Disciplina</label>
                        <input id="disciplinaAula" v-model="disciplina" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Disciplina" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="numeroFalta" class="form-label">Número</label>
                        <input id="numeroFalta" v-model="numero" @keyup="apertouEnter" type="text" class="form-control form-control-solid" placeholder="Número da aula" />
                    </div>  
                    <div class="col-12 col-lg-2 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm mt-5" @click="limparFiltros">
                            Limpar filtros
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada()"
                    :pesquisar="false">
                    <th>Data</th>
                    <th>Aluno</th>
                    <th style="min-width:70px">Pel</th>
                    <th>Disciplina</th>
                    <th>Turma</th>
                    <th style="min-width:90px">Aula</th>
                    <th>Motivo</th>
                    <th style="min-width:100px">Amparo</th>
                    <th style="min-width:90px">Status</th>
                    <th style="min-width:110px">Situacao</th>
                    <th style="min-width:200px" class="text-center" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import FaltaService from "@/service/v1/sigap/FaltaService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "FaltaIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class FaltaIndex extends IndexModelTable {
    public modal_visualizar = "modal_visualizar_falta";

    public status_id: any = 1;
    public status: any = null;
    public data_min: any = null;
    public data_max: any = null;
    public meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    public dias = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
    public cpf = "";
    public numero = "";
    public pelotao = ""; 
    public search = "";
    public turma = "";
    public disciplina = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get hj() {
        return new Date().getFullYear() + "-" + this.meses[new Date().getMonth()] + "-" + this.dias[new Date().getDate()];
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() {
        this.search = "";
        this.data_min = null;
        this.data_max = null;
        this.cpf = "";
        this.status_id = null;
        this.numero = "";
        this.pelotao = ""; 
        this.turma = "";
        this.disciplina = "";
        this.refreshTable();
    }

    created() {
        this.service = new FaltaService();
        this.getStatus();
        this.config.order = [[0, "desc"],[1, "asc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    cpf: this.cpf, 
                    status: this.status_id,
                    pelotao: this.pelotao, 
                    numero: this.numero,
                    disciplina: this.disciplina,
                    turma: this.turma,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.columns = [
            { data: "data", name: "data" },
            { data: "aluno", name: "aluno" },
            { data: "pelotao", name: "pelotao", class: "desktop" },
            { data: "disciplina", name: "disciplina" },
            { data: "disciplina.turma", name: "disciplina.turma", class: "desktop" },
            { data: "aula", name: "aula", class: "desktop" },
            { data: "faltaMotivo", name: "faltaMotivo", class: "desktop" },
            { data: "faltaTipo", name: "faltaTipo", class: "desktop" },
            { data: "status", name: "status", searchable: false, class: "text-center desktop" },
            { data: "situacao", name: "situacao", searchable: false, class: "text-center desktop" },
        ];
        this.config.columnDefs = [
            {
                targets: 0,
                render: function (row, type, val) {
                    return SiteUtils.formatData(val.aula.data);
                }
            },
            {
                targets: 1,
                render: function (row, type, val) {
                    return val.matricula?.usuario?.nome || "";
                }
            },
            {
                targets: 2,
                render: function (row, type, val) {
                    return val.matricula.pelotao;
                }
            },
            {
                targets: 3,
                render: function (row) {
                    return row != null ? row.descricao : "";
                }
            },
            {
                targets: 4,
                render: function (row) {
                    return row != null ? row.descricao : "";
                }
            },
            {
                targets: 5,
                render: function (row) {
                    return row != null ? row.numero : "";
                }
            },
            {
                targets: 6,
                render: function (row) {
                    return row.nome.replaceAll("_", " ");
                }
            },
            {
                targets: 7,
                render: function (row) {
                    return row.nome.replaceAll("_", " ");
                }
            },
            {
                targets: 8,
                render: function (row) {
                    return row.nome.replaceAll("_", " ");
                }
            },
            {
                targets: 9,
                render: function (row) {
                    return row.nome.replaceAll("_", " ");
                }
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 10,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-falta ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-show-falta]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            const routeData = this.$router.resolve({ name: "sigap_falta_show", params: { id: id } });
            window.open(routeData.href, "_blank");
        });
    }
}
</script>

<style scoped>
.falta-index-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
    padding: 0.55rem 1.25rem;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
